import React, { CSSProperties } from "react";

type CardMedicalReportPdfViewerProps = {
  id?: any;
  src: string;
  style: CSSProperties;
};

const CardMedicalReportPdfViewer = (props: CardMedicalReportPdfViewerProps) => {
  return props.src ? (
    <iframe
      id={props.id ?? "MedicalReportPdfViewer-Iframe-PDFViewer"}
      key={props.src}
      title="pdf-viewer"
      src={props.src}
      width="100%"
      height="100%"
      style={props.style}
    />
  ) : (
    <iframe
      id={props.id ?? "MedicalReportPdfViewer-Iframe-PDFViewer"}
      title="pdf-viewer"
      style={{ width: "100%", height: "calc(90vh - 10rem)" }}
    />
  );
};

export default React.memo(CardMedicalReportPdfViewer);
